export const langGPS = {
  fr: {
    sessionsLink: 'Sessions',
    sessionStatsLink: 'Détails session',
    gpsLink: 'Données GPS',
    save: 'Enregistrer',
    sourceFile: `Source : `,
    help: [
      'Vous pouvez exclure des périodes de la session si vous souhaitez affiner vos stats.',
      `Pour exclure une période :`,
      `- positionnez le slider rouge situé sous le graphe sous la période concernée`,
      `- cliquez sur le bouton + situé à droite du slider`,
      `- ajustez la période à exclure en utilisant le slider ajouté. Les points correspondants de la trace GPS apparaissent en rouge`,
      `- si vous souhaitez réintégrer une période exclue, cliquez sur le bouton - à droite du slider correspondant`,
      `Une fois vos périodes à exclure positionnées, cliquez sur le bouton Enregistrer.`,
      'Vous pourrez si nécessaire revenir sur vos choix plus tard et ajouter ou supprimer des périodes exclues enregistrées.',
    ],
  },
  eng: {
    sessionsLink: 'Sessions',
    sessionStatsLink: 'Session details',
    gpsLink: 'GPS data',
    save: 'Save',
    sourceFile: `Source : `,
    help: [
      'You can exclude periods from the session if you want to refine your stats.',
      `To exclude a period :`,
      `- position the red slider located under the graph under the period concerned`,
      `- click on the + button located to the right of the slider`,
      `- adjust the period to exclude using the added slider. The corresponding points of the GPS track appear in red`,
      `- if you wish to reinstate an excluded period, click on the - button to the right of the corresponding slider`,
      `Once your periods to exclude have been positioned, click on the Save button.`,
      'If necessary, you can reconsider your choices later and add or delete saved excluded periods.',
    ],
  },
}
